<template>
  <div>
    <div class="evaluation-explain-counter">
      <div class="explain-counter">
        <van-icon name="warning" size="80" color="#ff8e20" />
        <div class="survey-explain">
          暂无此权限
        </div>
        <van-button
          type="primary"
          style="margin-top: 25px"
          size="large"
          @click="$router.back()"
          >返回</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.evaluation-explain-counter {
  padding: 12px;
  box-sizing: border-box;
  height: calc(100vh - 45px);
  margin-top: 45px;
  text-align: center;
  .explain-counter {
    margin-top: 100px;
    .survey-explain {
      font-size: 15px;
      color: #666;
      margin-top: 10px;
    }
  }
}
</style>